import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { DataExtractionService } from '@/infra/services/data-extraction';

interface UseGetActionPlanColumnsParams {
	data_extraction_id: string;
}

const Service = DataExtractionService.getInstance();

export const useGetActionPlanColumns = (params: UseGetActionPlanColumnsParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.DATA_EXTRACTION_ACTION_PLAN_COLUMNS, params.data_extraction_id],
		queryFn: async () => Service.getActionPlanColumns(params)
	});
};
